import { ReactNode, useContext } from "react";
import { Box } from "@mui/material";
import AuthContext from "../../context/AuthContext";

interface Props {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export const DocumentsTopNavbar = ({ title, subtitle, actions }: Props) => {
  const { onLogout } = useContext(AuthContext);

  return (
    <Box
      component="header"
      sx={{
        height: 66,
        flexShrink: 0,
        background: "#fff",
        borderBottom: "1px solid #E7E7E3",
        display: "flex",
        alignItems: "center",
        px: "26px",
        gap: 2,
      }}
    >
      <Box sx={{ lineHeight: 1.15 }}>
        <Box sx={{ fontSize: 19, fontWeight: 700, color: "#2A2F38" }}>
          {title}
        </Box>
        {subtitle ? (
          <Box sx={{ mt: 0.25, fontSize: 12, color: "#8A8F99" }}>
            {subtitle}
          </Box>
        ) : null}
      </Box>

      <Box
        sx={{
          ml: "auto",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {actions}
        <Box
          component="button"
          onClick={onLogout}
          title="Sign out"
          aria-label="Sign out"
          sx={{
            width: 40,
            height: 40,
            borderRadius: "10px",
            border: "none",
            background: "#ED8B00",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            flexShrink: 0,
            "&:hover": { background: "#D97A00" },
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.9"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </Box>
      </Box>
    </Box>
  );
};
